import { JSX } from "react";
import { BaseComponent } from "../../Core/BaseComponent/BaseComponent";
import { SerendieSymbol } from "@serendie/symbols";

export class TickSymbol extends BaseComponent<ITickSymbolProps, ITickSymbolState>
{
    public static enabledAriaLabel = '';
    public static disabledAriaLabel = '';

    public render(): JSX.Element
    {
        const { value } = this.props;

        return (
            <SerendieSymbol
                name={value ? 'check-circle' : 'close-circle'}
                color={value ? 'var(--colors-sd-reference-color-scale-green-600)' : 'var(--colors-sd-reference-color-scale-red-400)'}
                style={{ marginLeft: 'var(--spacing-sd-system-dimension-spacing-two-extra-large)' }}
                aria-label={value ? TickSymbol.enabledAriaLabel : TickSymbol.disabledAriaLabel}
            />
        );
    }
}

export interface ITickSymbolProps
{
    value: boolean;
}

export interface ITickSymbolState { }
